/**
 * staffDetails.js
 * organizations.staff_details satirlarinin form tarafindaki ortak yardimcilari.
 *
 * Eski kayitlarda ad ve gorev tek alanda "AD SOYAD/GÖREV" seklinde tutuluyordu.
 * Formda artik ayri sutunlar var; yuklerken eski kayitlar otomatik bolunur.
 */

export const emptyStaffRow = () => ({
  staff_name: '',
  role: '',
  count: 1,
  start_time: '',
  end_time: '',
  unit_price: ''
});

/** Tek bir kaydi formun bekledigi sekle donusturur */
export function toFormStaffRow(row = {}) {
  const rawRole = String(row.role || '').trim();
  const hasName = String(row.staff_name || '').trim() !== '';

  let staffName = String(row.staff_name || '').trim();
  let role = rawRole;

  // Eski format: "ÜMİTCAN DOĞAN/SEDYE"
  if (!hasName && rawRole.includes('/')) {
    const slashIdx = rawRole.lastIndexOf('/');
    staffName = rawRole.slice(0, slashIdx).trim();
    role = rawRole.slice(slashIdx + 1).trim();
  }

  return {
    staff_name: staffName,
    role,
    count: parseInt(row.count, 10) || 1,
    start_time: row.start_time || '',
    end_time: row.end_time || '',
    unit_price: row.unit_price ?? ''
  };
}

/** Kaydetmeden once: bos satirlari atar, fiyati sayiya cevirir */
export function toApiStaffRows(rows = []) {
  return rows
    .filter(r => String(r.staff_name || '').trim() || String(r.role || '').trim())
    .map(r => ({
      staff_name: String(r.staff_name || '').trim(),
      role: String(r.role || '').trim(),
      count: parseInt(r.count, 10) || 1,
      start_time: r.start_time || '',
      end_time: r.end_time || '',
      unit_price:
        r.unit_price === '' || r.unit_price === null || r.unit_price === undefined
          ? 0
          : parseFloat(String(r.unit_price).replace(',', '.')) || 0
    }));
}

/** Listede gosterim icin: "AD SOYAD — GÖREV" */
export function staffDisplayName(row = {}) {
  const formatted = toFormStaffRow(row);
  return [formatted.staff_name, formatted.role].filter(Boolean).join(' — ');
}
